import api from "../services/api"
import { IClientDataSend } from "./Clients"

export const sendClientData = async (payload: IClientDataSend[]) => {
    await api.sendClientData(payload)
}